import { Controller } from "@hotwired/stimulus"

// Settings → CRM → Regulatory Requirements → Quiet Hours (#18465): keeps the
// plain-English recap in sync with the Start / Stop time pickers, and warns when
// the stop is not after the start. Quiet Hours is the one outreach-hours setting
// (owner 2026-10-21); the recap moved here from the retired Preferences →
// Outreach Hours card. The server renders the same sentence first
// (RegulatoryRequirementsHelper#quiet_hours_summary) — keep the two in step.
export default class extends Controller {
  static targets = ["start", "end", "summary", "summaryText", "warning"]

  connect() {
    this.update()
  }

  update() {
    if (!this.hasStartTarget || !this.hasEndTarget) return

    const start = this.minuteOf(this.startTarget.value)
    const end = this.minuteOf(this.endTarget.value)
    const invalid = start === null || end === null || end <= start

    if (this.hasWarningTarget) this.warningTarget.classList.toggle("d-none", !invalid)
    if (this.hasSummaryTarget) this.summaryTarget.classList.toggle("d-none", invalid)
    if (!invalid && this.hasSummaryTextTarget) {
      this.summaryTextTarget.textContent =
        `You'll call and text your leads between ${this.clock(start)} and ` +
        `${this.clock(end)}, in each lead's local time.`
    }
  }

  // "08:30" → 510; null when the picker is empty or not HH:MM.
  minuteOf(value) {
    const match = /^(\d{2}):(\d{2})/.exec(value || "")
    if (!match) return null
    return parseInt(match[1], 10) * 60 + parseInt(match[2], 10)
  }

  // 510 → "8:30 AM", 1260 → "9:00 PM".
  clock(minuteOfDay) {
    const hour = Math.floor(minuteOfDay / 60)
    const minute = minuteOfDay % 60
    const hour12 = hour % 12 === 0 ? 12 : hour % 12
    const suffix = hour < 12 ? "AM" : "PM"
    return `${hour12}:${String(minute).padStart(2, "0")} ${suffix}`
  }
}
